// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filters___RonUb{--perxis-auto-filters-top-inner: var(--perxis-auto-filters-top, 0);--perxis-auto-filters-left-inner: var(--perxis-auto-filters-sticky-left, 0);position:sticky;top:var(--perxis-auto-filters-top-inner);left:var(--perxis-auto-filters-left-inner)}.filtersWrapper___tXh8A .ant-5_15_3-modal-body{padding:0 !important}.filtersParameters___JNE9j{height:100%;padding-bottom:var(--perxis-auto-gap-vertical-yellow-inner);overflow-y:auto;-ms-overflow-style:none;scrollbar-width:none}.filtersParameters___JNE9j::-webkit-scrollbar{display:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filters": `filters___RonUb`,
	"filtersWrapper": `filtersWrapper___tXh8A`,
	"filtersParameters": `filtersParameters___JNE9j`
};
export default ___CSS_LOADER_EXPORT___;
